import { Suspense, useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';

import { ReactQueryDevtools } from 'react-query/devtools';

import { FullPageError } from '@leagueplatform/web-common-components';
import { config } from 'init-config';
import { ErrorBoundaryWrapper } from 'components/error/error-boundary.component';
import { APP_MANAGED_ROUTES } from 'common/constants';
import { QueryClientProvider } from 'react-query';
import League from '@leagueplatform/core';
import { useApp } from 'hooks/use-app.hook';
import { FullPageLoadingSpinner } from 'components/loaders/full-page-loading-spinner.component';
import {
  installSafariProvisionalExternalTabListener,
  uninstallSafariProvisionalExternalTabListener,
} from 'utils/safari-external-link-provisional';
import AppRoutes from './components/AppRoutes';

const AppShell = () => {
  const { isOnline, isOffline, queryClient, initializeApp } = useApp();

  useEffect(() => {
    installSafariProvisionalExternalTabListener();
    return () => uninstallSafariProvisionalExternalTabListener();
  }, []);

  useEffect(() => {
    initializeApp();
  }, [initializeApp]);

  return (
    <QueryClientProvider client={queryClient}>
      <League.LeagueProvider config={config} treatConfigAsInitialOnly>
        <ErrorBoundaryWrapper>
          <Suspense fallback={<FullPageLoadingSpinner />}>
            {isOffline && (
              <FullPageError
                route={APP_MANAGED_ROUTES.HOME}
                error={undefined}
              />
            )}
            {isOnline && (
              <ErrorBoundaryWrapper>
                <Outlet />
              </ErrorBoundaryWrapper>
            )}
            <ReactQueryDevtools />
          </Suspense>
        </ErrorBoundaryWrapper>
      </League.LeagueProvider>
    </QueryClientProvider>
  );
};

const router = createBrowserRouter([
  {
    path: '*',
    element: <AppShell />,
    children: [{ path: '*', element: <AppRoutes /> }],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
